// @ts-nocheck
import React from 'react';
import { styled } from '@mui/material/styles';
import { BotonVerde } from '../Difusiones/Componentes/BotonVerde';
import { Check, Send } from './Icons';
import SinapTheme from "../styles/SinapTheme";
import { BotonSecondary } from "./BotonSecondary";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Grid, Stack, Typography, Button, Box, Modal } from '@mui/material';

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    boxShadow: theme.shadows[5],
    borderRadius: '12px',
    padding: theme.spacing(4),
    width: '85%',
    maxWidth: 500,
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(3),
    },
}));

export function ModalConfirmacion({ accion, mensajePrimario, mensajeSecundario, botonApertura,
    mensajeApertura, mensajeAceptar, colorAceptar, condicionDeApertura, setAlert, mensajeFalloApertura, disabled }) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = condicionDeApertura ? () => {
        if (condicionDeApertura) setAlert(mensajeFalloApertura);
        else setOpen(true);
    } :
        () => setOpen(true);
    const handleClose = () => setOpen(false);
    let BotonApertura = null;
    if (botonApertura == "Enviar")
        BotonApertura = <Send onClick={handleOpen} style={{ marginLeft: '0px' }} color={SinapTheme.palette.primary.main} />
    if (botonApertura == "BotonVerde")
        BotonApertura = <BotonVerde disabled={disabled} style={{ marginLeft: '0px' }} variant="contained" onClick={handleOpen}>{mensajeApertura}</BotonVerde>;
    if (botonApertura == "BotonRojo")
        BotonApertura = <Button color="primary" style={{ marginLeft: '0px' }} variant="contained" onClick={handleOpen} disabled={disabled}>{mensajeApertura}</Button>;
    if (botonApertura == "Check")
        BotonApertura = <Check color={SinapTheme.palette.success.dark} onClick={handleOpen} />
    return (
        <>
            {BotonApertura}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box>
                    <ContenedorConfirmacion
                        accion={accion}
                        mensajePrimario={mensajePrimario}
                        mensajeSecundario={mensajeSecundario}
                        mensajeAceptar={mensajeAceptar}
                        handleClose={handleClose}
                        colorAceptar={colorAceptar}
                    />
                </Box>
            </Modal>
        </>
    );
}

export function ContenedorConfirmacion({ accion, mensajePrimario, mensajeSecundario,
    colorAceptar, mensajeAceptar, handleClose }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const aceptar = () => {
        handleClose();
        accion();
    }

    return (
        <>
            <Root>
                <Grid container spacing={3} justifyContent="center" alignItems="center" direction="column">
                    <Grid item xs={12}>
                        <Typography component="div" variant="h6" align="center" color="textPrimary" gutterBottom>
                            {mensajePrimario}
                        </Typography>
                    </Grid>

                    {mensajeSecundario && (
                        <Grid item xs={12}>
                            <Typography component="div" variant="body2" align="center" color="textSecondary">
                                {mensajeSecundario}
                            </Typography>
                        </Grid>
                    )}

                    <Grid item xs={12} container spacing={2} justifyContent="center">
                        <Grid item>
                            <Button variant="outlined" size={isMobile ? 'small' : 'medium'} onClick={handleClose}>
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                onClick={aceptar}
                                size={isMobile ? 'small' : 'medium'}
                                sx={{
                                    backgroundColor: colorAceptar,
                                    color: '#ffffff',
                                    '&:hover': {
                                        backgroundColor: "#378a3a",
                                    },
                                }}
                            >
                                {mensajeAceptar}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Root>
        </>
    );
}